let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Qr6L")).then(() => parcelRequire('3dKZY'));